import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type AccountSettings } from '../../../../../../src/types/AccountSettings';

/**
 * Opinionated API to fetch data for the Account Settings page
 */
export async function getApiV2CustomersCustomerIdAccountSettings() {
  return await send<AccountSettings>({
    path: `/api/v2/customers/self/account_settings/`,
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
